import { IconName } from '@frontend/icons';

export enum Verticals {
  DENTAL = 'Dental',
  ORTHO = 'Ortho',
  VET = 'Vet',
  OPTO = 'Opto',
  MEDICAL = 'Medical',
  MEDSPA = 'MedSpa',
  ALL = 'All',
}

export const verticalsIconNameMap: Record<Verticals, IconName> = {
  [Verticals.DENTAL]: 'tooth',
  [Verticals.ORTHO]: 'bone',
  [Verticals.VET]: 'paw',
  [Verticals.OPTO]: 'view',
  [Verticals.MEDICAL]: 'medical-filled',
  [Verticals.MEDSPA]: 'hourglass',
  [Verticals.ALL]: 'analytics',
};

export enum Confirmation {
  YES = 'Yes',
  NO = 'No',
}

export enum UserRole {
  ENGINEERING = 'ENGINEERING',
  SALES = 'SALES',
  SUPPORT = 'SUPPORT',
  PRODUCT = 'PRODUCT',
  ONBOARDING_CSM_SW = 'ONBOARDING_CSM_SW',
  LEADERSHIP = 'LEADERSHIP',
  ALL = 'ALL',
}

export enum IntegrationOverviewTab {
  SUPPORTED_FEATURES = 'Supported Features',
  FAQS = "FAQ's",
  QUICK_LINKS = 'Quick Links',
  EXTERNAL_PARTNER_RESOURCES = 'External Partner Resources',
  PARTNER_INFORMATION = 'Partner Information',
  SUPPORTED_PMS_VERSIONS = 'Supported PMS Versions',
  OPERATING_SYSTEM = 'Operating System',
}

export enum PartnerInformationFields {
  PARENT_COMPANY = 'Parent Company',
  PARTNER_STATUS = 'Partner Status',
  PARTNER_INTEGRATION_STATUS = 'Partner Integration Status',
  AUTHORIZED_INTEGRATION_SINCE = 'Authorized Integration Since',
  PARTNER_DETAILS = 'Partner Details',
}
